import {getArrivalGuaranteeValidate} from '@web/actions/deliveryInfo'
import {getShoppingSubscriptionResultInfo} from '@web/actions/result'
import {ProcessStatus, resetProcessStatus} from '@web/slices/shoppingSubscription/slice'
import makeSlice from '@web/slices/shoppingSubscription/sliceMaker'

import {startSubscription, fetchApplyStatus, apply, fetchSubscription} from '../../actions'
import {SubscriptionProcessExceptionCode} from '../../constants'

import {getProcessExceptionStatus, getProcessStatus} from './utils'

const slice = makeSlice({
    extraReducers(builder) {
        builder
            .addCase(
                fetchSubscription.fulfilled,
                (state, {payload: {subscriptionViewResult, paymentMethodsResult}}) => {
                    state.firstDeliveryDate = subscriptionViewResult.subscription.firstDeliveryDate
                    state.firstPaymentDate = subscriptionViewResult.subscription.firstPaymentDate
                    state.periodCount = subscriptionViewResult.subscription.periodCount
                    state.periodType = subscriptionViewResult.subscription.periodType
                    state.paymentMethodSeqNo = paymentMethodsResult?.directOrderPayMethodNo ?? null
                    state.selectableMaxPeriodCount = subscriptionViewResult.subscription.selectableMaxPeriodCount
                    state.isImmediatePayment = subscriptionViewResult.subscription.immediatelyPayment
                    state.processStatus = ProcessStatus.READY
                },
            )
            .addCase(getArrivalGuaranteeValidate.pending, (state) => {
                state.processStatus = ProcessStatus.PENDING
            })
            .addCase(resetProcessStatus, (state) => {
                state.processStatus = ProcessStatus.IDLE
            })
            .addCase(startSubscription.pending, (state) => {
                state.processStatus = ProcessStatus.PENDING
            })
            .addCase(startSubscription.fulfilled, (state, {payload}) => {
                state.reservedId = payload.subscriptionProcessId
                state.processStatus = ProcessStatus.SUCCESS
            })
            .addCase(startSubscription.rejected, (state) => {
                state.processStatus = ProcessStatus.READY
            })
            .addCase(fetchApplyStatus.fulfilled, (state, {payload}) => {
                state.processStatus = getProcessStatus(payload)
            })
            .addCase(fetchApplyStatus.rejected, (state, {payload}) => {
                state.processStatus = getProcessExceptionStatus(
                    payload ?? SubscriptionProcessExceptionCode.SUBSCRIPTION_PROCESS_FAILED_DEFAULT,
                )
            })
            .addCase(apply.fulfilled, (state, {payload}) => {
                state.processStatus = getProcessStatus(payload)
            })
            .addCase(apply.rejected, (state, {payload}) => {
                state.processStatus = getProcessExceptionStatus(
                    payload ?? SubscriptionProcessExceptionCode.SUBSCRIPTION_PROCESS_FAILED_DEFAULT,
                )
            })
            .addCase(
                getShoppingSubscriptionResultInfo.fulfilled,
                (
                    state,
                    {
                        payload: {
                            subscriptionResultViewInfo: {subscriptionApplicationView},
                        },
                    },
                ) => {
                    state.isImmediatePayment = subscriptionApplicationView.immediatelyPayment
                    state.isImmediatePaymentSuccess = subscriptionApplicationView.immediatelyPaymentSuccess ?? false
                },
            )
    },
})

export default slice.reducer
export const actions = slice.actions
